import React, { useState, useEffect } from "react";
import { Icon, Row, Col} from "antd";
import moment from "moment";
import useInterval from '../../hooks/useInterval'
import { secons2text } from "../../services/timeFunctions";
import { Wrapper, H3 } from "./styles";
import Table from "../../components/table";
import Search from "../../components/table/search";
import useManufacturingOrder from '../../hooks/useManufacturingOrder';
import { useTranslation } from 'react-i18next'

const RenderQuality = () => {
  const [,setManufacturingList] = useState(null);
  const [qualityArticle, setQualityArticle] = useState(null);
  const [furnaceArticle, setFurnaceArticle] = useState(null);
  const [setFurnaceNowTemperature] = useState(750);
  const { manufacturingOrder } = useManufacturingOrder();
  const { t } = useTranslation();

  useInterval(() => {
    setQualityArticle([...qualityArticle]);
  }, 1000);

  useEffect(()=>{
    let temp = localStorage.getItem('furnaceTemp');
    if (temp) setFurnaceNowTemperature(parseInt(temp));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  useEffect(() => {
    const filtered = manufacturingOrder.filter((order, i) => order.desing);
    const normalized = filtered.map((order, i) => {
      return {
        key: i,
        ...order
      };
    });

    const qualityList = [];
    const intoFurnaceList = [];
    filtered.forEach((order, i) => {
      order.pieces.forEach((piece, x) => {
        let a = {
          key: "que-"+x+"-"+piece.id,
          ...piece,
          ref: order.ref,
          furnace: order.desing.furnace,
          furnaceTime: piece.furnace,
          timeFurnace: 50,
          
          quenching: order.desing.quenching,
          quenchingTime: piece.quenching,
          timeQuenching: 50,
        };
        if(piece.quality && piece.quality.start && !piece.quality.end) qualityList.push(a);
        if(piece.quenching && piece.quenching.start && !piece.quenching.end) intoFurnaceList.push(a);
      });
    });

    setQualityArticle(qualityList);
    setFurnaceArticle(intoFurnaceList);
    normalized.length>0 && setManufacturingList(normalized);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manufacturingOrder]);

  const columnsAvailable = [
    {
      title: t('table.header.ref'),
      dataIndex: "ref",
      key: "ref",
      sorter: (a, b) => a.ref.localeCompare(b.ref),
      defaultSortOrder: "descend",
      ...Search("ref")
    },
    {
      title: t('table.header.number'),
      dataIndex: "id",
      key: "id"
    },
    {
      title: t('table.header.entry_date'),
      dataIndex: "quality.start",
      key: "quality.start",
      render: value => value.format("DD/MM/YYYY HH:mm:ss")
    },
    {
      title: t('phase.quality'),
      dataIndex: "quality.start",
      key: "quality.start",
      render: (text, record) => {
        return (
          !record.calidadP?<Icon type="close-circle" style={{ color: "#FF0000",fontSize:"3vh" }}/>:<Icon type="check-circle" style={{ color: "#00FF00",fontSize:"3vh" }}/>
        )
      }
    }
  ];

  const columnsFurnace = [
    {
      title: t('table.header.ref'),
      dataIndex: "ref",
      key: "ref",
      sorter: (a, b) => a.ref.localeCompare(b.ref),
      defaultSortOrder: "descend"
    },
    {
      title: t('table.header.number'),
      dataIndex: "id",
      key: "id"
    },
    {
      title: t('table.header.entry_date'),
      dataIndex: "quenchingTime.start",
      key: "quenchingTime.start",
      render: value => value.format("DD/MM/YYYY HH:mm:ss")
    },
    {
      title: t('table.header.exit_date'),
      dataIndex: "timeQuenching",
      key: "timeQuenching",
      render: (time, record) => {
        let start = record.quenchingTime.start;
        let sec = start.unix();
        return moment((sec+time)*1000).format("DD/MM/YYYY HH:mm:ss")
      }
    },
    {
      title: t('table.header.remaining_time'),
      dataIndex: "timeQuenching",
      key: "timeQuenching",
      render: (time, record) => {
        let start_sec = record.quenchingTime.start.unix();
        let end_sec = start_sec+time;
        let plusTime = (record.quenchingTime.plusTime) ? record.quenchingTime.plusTime : 0; 
        let this_sec = moment().unix() + plusTime;
        let difference = end_sec-this_sec;
        let negative = difference < 0;

        return (negative) ?  <h3 style={{color: "red"}}>{"- " + secons2text(-1*difference)}</h3> : <h3>{secons2text(difference)}</h3>;
      }
    },
  ];

  return (
    <Wrapper>
      <Row style={{ margin: 0 }} gutter={[16, 16]}>
        <Col xl={10} lg={10} md={24}>
          <H3>{t('headers.control_process.pieces_in_quenching', {value: furnaceArticle && furnaceArticle.length})}</H3>
          <Table data={furnaceArticle} columns={columnsFurnace} pagination={{ pageSize: 5 }}/>
        </Col>
        <Col xl={2} lg={4} md={24} style={{height: "calc(70vh)"}}>
          <Col span={24}></Col>
          <Col span={24}></Col>
          <Col span={24}></Col>
        </Col>
        <Col xl={12} lg={10} md={24} style={{height: "calc(60vh - 210px)"}}>
          <Row>
            <Col span={8}> 
            </Col>
            <Col span={8}> 
              <H3>{t('headers.control_process.pieces_in_quality', {value: qualityArticle && qualityArticle.length})}</H3>
            </Col>
            <Col span={8}> 
            </Col>
          </Row>
          <Table data={qualityArticle} columns={columnsAvailable}  pagination={{ pageSize: 5 }}/>
        </Col>
      </Row>
    </Wrapper>
  );
};
export default RenderQuality;
